export default {
    brand_delete_title: "Delete Brand",
    brand_delete_success_message: "The brand has been deleted",
    brand_delete_message: "Are you sure you want to delete the brand?",
    brand_delete_general_error: "It was not possible to delete the brand due to an error",
    brand_delete_package_in_use_dealer: "The brand is linked to some dealers so it is not possible to delete it",
}